import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { updateFavoriteModel } from 'services/ModelService';
import { LogyxError, getToastErrorMessage } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';

interface IUpdateFavoriteModelParams {
  modelId: number;
  isFavorite: boolean;
}

export const useUpdateFavoriteModel = () => {
  const { t } = useTranslation();
  return useMutation(
    (params: IUpdateFavoriteModelParams) => {
      return updateFavoriteModel(params.modelId, params.isFavorite);
    },
    {
      onSuccess: (_, params: IUpdateFavoriteModelParams) => {
        toast.success(
          params.isFavorite
            ? t('Model added to favourites')
            : t('Model removed from favourites')
        );
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error), {
          toastId: ReactMutationKeys.UPDATE_FAVORITE_MODEL,
        });
      },
      mutationKey: ReactMutationKeys.UPDATE_FAVORITE_MODEL,
    }
  );
};
